import React, { FC } from 'react';
import { PrintableContainer } from '@web/components/printable-container';
import { BmisPDFHeader } from '@web/bmis/components/bmis-pdf/pdf-header';
import { DMSPdfBody } from './dms-pdf-body';
import { useDmsState } from '@packages/contexts/dms';

export interface BmisPDFProps {
    componentRef: React.RefObject<HTMLDivElement>;
    isPrintLoading: boolean;
}

export const DMSPdf: FC<BmisPDFProps> = ({ componentRef, isPrintLoading }) => {
    const { selectedRepairOrder } = useDmsState();

    return (
        <PrintableContainer
            ref={componentRef}
            allowPrint={isPrintLoading}
            header={<BmisPDFHeader />}
            body={selectedRepairOrder ? <DMSPdfBody /> : null}
        />
    );
};
